import React from 'react'
import { Tab as SemanticTab } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

// TODO: This Tab seems to be busted.  Also not sure why we have this one to begin with as we have one in core.
const Tab = props => {
  return (
    <SemanticTab
      className={cx('tab')}
      menu={{ secondary: true, pointing: true, className: cx('tab-menu') }}
      {...props}
    />
  )
}

Tab.propTypes = {
  ...SemanticTab.PropTypes,
}

Tab.Pane = SemanticTab.Pane

export default Tab
